<template>
  <div style="width: 100%">
    <div class="pamadeng" @click="announcementHandle">
      <img src="../../assets/images/announcement_icon.png">
      <Marquee style=" padding:9px 0px;margin-left: 50px;margin-right: 20px;color:red"> 系统部分功能暂停通知 </Marquee>
    </div>
    <div class="page-content-box searchcontent" style="min-width:900px">
      <div class="page-content-list fr-s-s warp">
        <div class="page-content-list-item fr-b-c m-b-10">
          <div class="flex-1">
            <div class="page-content-list-item-title">
              申报总人数
            </div>
            <div class="page-content-list-item-main">
              <div class="page-content-list-item-number text-line-1">
                {{ acceptNum }}
                <span class="page-content-list-item-type">人</span>
              </div>
            </div>
          </div>
          <div class="page-content-list-item-right">
            <img src="../../assets/images/welcome_one.png" alt="">
          </div>
        </div>
        <div class="page-content-list-item fr-b-c m-b-10">
          <div class="flex-1">
            <div class="page-content-list-item-title">
              待审核人数
            </div>
            <div class="page-content-list-item-main">
              <div class="page-content-list-item-number text-line-1">
                {{ pendingReviewNum }}
                <span class="page-content-list-item-type">人</span>
              </div>
            </div>
          </div>
          <div class="page-content-list-item-right">
            <img src="../../assets/images/welcome_three.png" alt="">
          </div>
        </div>
        <div class="page-content-list-item fr-b-c m-b-10">
          <div class="flex-1">
            <div class="page-content-list-item-title">
              待公示人数
            </div>
            <div class="page-content-list-item-main">
              <div class="page-content-list-item-number text-line-1">
                {{ pendingPublicityNum }}
                <span class="page-content-list-item-type">人</span>
              </div>
            </div>
          </div>
          <div class="page-content-list-item-right">
            <img src="../../assets/images/welcome_two.png" alt="">
          </div>
        </div>
        <div class="page-content-list-item fr-b-c m-b-10">
          <div class="flex-1">
            <div class="page-content-list-item-title">
              退出人数
            </div>
            <div class="page-content-list-item-main">
              <div class="page-content-list-item-number text-line-1">
                {{ exitNum }}
                <span class="page-content-list-item-type">人</span>
              </div>
            </div>
          </div>
          <div class="page-content-list-item-right">
            <img src="../../assets/images/welcome_four.png" alt="">
          </div>
        </div>
        <div class="page-content-list-item fr-b-c">
          <div class="flex-1">
            <div class="page-content-list-item-title">
              “退休一件事”申报总人数
            </div>
            <div class="page-content-list-item-main">
              <div class="page-content-list-item-number text-line-1">
                {{ acceptNumRetire || 0 }}
                <span class="page-content-list-item-type">人</span>
              </div>
            </div>
          </div>
          <div class="page-content-list-item-right">
            <img src="../../assets/images/welcome_one.png" alt="">
          </div>
        </div>
        <div class="page-content-list-item fr-b-c">
          <div class="flex-1">
            <div class="page-content-list-item-title">
              “退休一件事”待审核人数
            </div>
            <div class="page-content-list-item-main">
              <div class="page-content-list-item-number text-line-1">
                {{ pendingReviewNumRetire || 0 }}
                <span class="page-content-list-item-type">人</span>
              </div>
            </div>
          </div>
          <div class="page-content-list-item-right">
            <img src="../../assets/images/welcome_three.png" alt="">
          </div>
        </div>
        <div class="page-content-list-item fr-b-c">
          <div class="flex-1">
            <div class="page-content-list-item-title">
              “退休一件事”待公示人数
            </div>
            <div class="page-content-list-item-main">
              <div class="page-content-list-item-number text-line-1">
                {{ pendingPublicityNumRetire || 0 }}
                <span class="page-content-list-item-type">人</span>
              </div>
            </div>
          </div>
          <div class="page-content-list-item-right">
            <img src="../../assets/images/welcome_two.png" alt="">
          </div>
        </div>
        <div class="page-content-list-item fr-b-c">
          <div class="flex-1">
            <div class="page-content-list-item-title">
              “退休一件事”办结人数
            </div>
            <div class="page-content-list-item-main">
              <div class="page-content-list-item-number text-line-1">
                {{ exitNumRetire || 0 }}
                <span class="page-content-list-item-type">人</span>
              </div>
            </div>
          </div>
          <div class="page-content-list-item-right">
            <img src="../../assets/images/welcome_four.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="searchchart searchtable" style="min-width:900px">
      <div class="searchchartb-list">
        <div style="font-size:18px" class="searchchart_header">
        </div>
        <div class="searchchart_echarts">
          <!-- 柱状图 月份-->
          <div class="searchchart_bottom">
            <div id="oneChart" style="height:400px;"></div>
          </div>
          <!-- 柱状图 -->
          <div class="searchchart_bottom echartsleft">
            <div id="twoChart" style="height:400px;"></div>
          </div>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
import {
  baseconfig,
  rsaBasicModuleConfig,
  rsaMainModuleConfig,
} from '@/config.js'
import { rsa } from '@/tools/encrypt.js'
import { publicFun } from '@/tools/time.js'
import { indexModule } from '@/request/welcome.js'
import { permissionTool } from '@/tools/permissiontool.js'
import store from '@/store'
import $ from 'jquery'
import { sysframe } from '@/tools/sysframe.js'
import { downloadFile } from '@/request/utils/downloadexcel.js'
import Marquee from './Marquee.vue'


import * as echarts from 'echarts'
export default {
  components: {
    Marquee
  },
  data() {
    return {
      isshow: false,
      //月份柱状图
      monthList: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
      ],
      legendlist: [],
      allPolicy: [],
      //政策柱状图
      policyNameList: [],
      policyNumList: [],
      // 柱状图
      noList: [],
      noListname: [],
      noListnum: [],

      addbuttonloading: false,
      addbuttondisabled: false,
      days: 0,
      disinformation: false,
      successrate: 0,
      successratelist: [],
      appearsuccessrate: 0,
      appearsuccessratelist: [],
      // 审核数
      acceptNum: '',
      pendingReviewNum: '',
      pendingPublicityNum: '',
      exitNum: '',

      // 退休审核数
      acceptNumRetire: '',
      pendingReviewNumRetire: '',
      pendingPublicityNumRetire: '',
      exitNumRetire: '',
    }
  },
  mounted() {
    //echarts的自适应设置
    //   this.$nextTick(()=>{
    //       this.drawLine()
    //       this.drawLineright()
    //   })
  },
  created: async function () {
    await this.gettasktrackinglist()

    this.tableHeight =
      $('.tab-content').height() -
      $('.searchcontent').outerHeight(true) -
      $('.pageblock').outerHeight(true)
  },
  methods: {
    initLeft() {
      return sysframe.getSideBarLeft()
    },

    announcementHandle() {
      if (this.$router.history.current.path != '/welcomenoticelist') {
        this.$router.push({
          path: '/welcomenoticelist',
        })
        this.$store.dispatch("tab/setActiveName", '/welcomenoticelist');
        let obj = { taburl: '/welcomenoticelist', tabicon: 'el-icon-message-solid', tabtitle: '公告查询' }
        this.$store.dispatch("tab/addTab", obj);
      }
    },



    //主页列表
    async gettasktrackinglist() {
      await indexModule
        .getindex()
        .then((response) => {
          switch (response.data.code) {
            case 100:
              {
                this.isshow = true
                let list = response.data.result
                // 审核人数
                this.acceptNum = list.acceptNum
                this.pendingReviewNum = list.pendingReviewNum
                this.pendingPublicityNum = list.pendingPublicityNum
                this.exitNum = list.exitNum
                // 退休人数
                this.acceptNumRetire = list.acceptNumRetire
                this.pendingReviewNumRetire = list.pendingReviewNumRetire
                this.pendingPublicityNumRetire = list.pendingPublicityNumRetire
                this.exitNumRetire = list.exitNumRetire

                this.policyNameList = []
                this.policyNumList = []
                this.allPolicy = []
                list.lsRewardCount.forEach((e) => {
                  this.policyNameList.push(e.policyMeasureName)

                  this.policyNumList.push(e.enjoyNum)
                })
                //  list.lsApplyCount = []
                if (list.lsApplyCount.length == 0) {
                  for (let i = 0; i < this.allPolicy.length; i++) {
                    this.allPolicy[i].data = [
                      '0',
                      '0',
                      '0',
                      '0',
                      '0',
                      '0',
                      '0',
                      '0',
                      '0',
                      '0',
                      '0',
                      '0',
                    ]
                  }
                } else {
                  list.lsApplyCount.forEach((e) => {
                    this.legendlist.push(e.policyMeasureName)
                    if (
                      this.legendlist.length == 2 ||
                      (this.legendlist.length - 2) % 3 == 0
                    ) {
                      this.legendlist.push('')
                    }
                    let list = {
                      name: e.policyMeasureName,
                      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                      type: 'bar',
                      barWidth: '20%',
                      stack: 'x',
                      tooltip: {
                        show: true,
                      },
                    }
                    this.allPolicy.push(list)
                    if (e.lsPolicyMeasure.length > 0) {
                      e.lsPolicyMeasure.forEach((e) => {
                        if (e.month == '01') {
                          list.data[0] = list.data[0] + e.applyNum
                        }
                        if (e.month == '02') {
                          list.data[1] = list.data[1] + e.applyNum
                        }
                        if (e.month == '03') {
                          list.data[2] = list.data[2] + e.applyNum
                        }
                        if (e.month == '04') {
                          list.data[3] = list.data[3] + e.applyNum
                        }
                        e
                        if (e.month == '05') {
                          list.data[4] = list.data[4] + e.applyNum
                        }
                        if (e.month == '06') {
                          list.data[5] = list.data[5] + e.applyNum
                        }
                        if (e.month == '07') {
                          list.data[6] = list.data[6] + e.applyNum
                        }
                        if (e.month == '08') {
                          list.data[7] = list.data[7] + e.applyNum
                        }
                        if (e.month == '09') {
                          list.data[8] = list.data[8] + e.applyNum
                        }
                        if (e.month == '10') {
                          list.data[9] = list.data[9] + e.applyNum
                        }
                        if (e.month == '11') {
                          list.data[10] = list.data[10] + e.applyNum
                        }
                        if (e.month == '12') {
                          list.data[11] = list.data[11] + e.applyNum
                        }
                      })
                    }
                  })
                }
                if (this.policyNumList.length > 0) {
                  this.$nextTick(() => {
                    this.policyHistogram()
                  })
                }
                if (this.allPolicy.length > 0) {
                  this.$nextTick(() => {
                    this.monthHistogram()
                  })
                }
              }

              break
            case 101:
              break
            case 102:
              this.$message.error(baseconfig.para_error_message)
              break
            case 100002:
              this.$message.error(baseconfig.no_permission_message)
              break
            default:
              this.$message.error(response.data.message)
              break
          }
        })
        .catch((error) => { })
    },

    // 柱状图(根据月份)
    monthHistogram() {
      let myChart = this.$echarts.init(document.getElementById('oneChart'))
      myChart.setOption({
        title: {
          text: '政策申报汇总',
          subtext: '申报数量',
          textStyle: {
            fontSize: 16,
          },
        },
        tooltip: {
          trigger: 'axis',
          // axisPointer: {            // 坐标轴指示器，坐标轴触发有效
          //     type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          // },
          // 'width:300px!important;height:'+this.policyNameList.length*17+39+'+px!important;'
          extraCssText: 'width:300px!important;',
        },
        xAxis: {
          type: 'category',
          data: this.monthList,
        },
        legend: {
          data: this.legendlist,
        },
        yAxis: {},
        series: this.allPolicy,
      })
    },
    // 柱状图(根据政策)
    policyHistogram() {
      let twoChart = this.$echarts.init(document.getElementById('twoChart'))
      twoChart.setOption({
        title: {
          text: '扶助对象汇总',
          subtext: '扶助数量',
          textStyle: {
            fontSize: 16,
          },
          subtextStyle: {
            align: 'right',
          },
        },
        tooltip: {
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
          extraCssText: 'width:300px;height:40px;',
        },
        xAxis: {
          type: 'category',
          data: this.policyNameList,
          axisLabel: {
            interval: 0,
            formatter: function (value) {
              /*return value.split("").join("\n");*/
              if (value.length > 10) {
                return value.substring(0, 10) + '..'
              } else {
                return value
              }
            },
          },
        },
        yAxis: {
          type: 'value',
        },
        legend: {
          data: ['扶助数量'],
        },

        series: [
          {
            name: '扶助数量',
            type: 'bar',
            barWidth: '5%',
            data: this.policyNumList,
          },
        ],
      })
    },
  },
}
</script>
<style scoped>
/* 公共 */
.fr-b-c {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -moz-box-pack: justify;
  -webkit--moz-box-pack: justify;
  box-pack: justify;
  align-items: center;
  -webkit-align-items: center;
  box-align: center;
  -moz-box-align: center;
  -webkit-box-align: center;
}

.fr-s-s {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  -moz-box-pack: start;
  -webkit--moz-box-pack: start;
  box-pack: start;
  align-items: flex-start;
  -webkit-align-items: flex-start;
  box-align: start;
  -moz-box-align: start;
  -webkit-box-align: start;
}


.flex-1 {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  flex: 1;
  -webkit-flex: 1;
}

.m-r-10 {
  margin-right: 10px;
}

.m-b-10 {
  margin-bottom: 10px;
}

.warp {
  -webkit-flex-wrap: wrap;
  -webkit-box-lines: multiple;
  -moz-flex-wrap: wrap;
  flex-wrap: wrap;
}

.page-content-box {
  background: #fff;
  padding: 10px;
  border-radius: 5px;
}

.page-content-list {
  width: 100%-15;
  display: flex;
  padding: 15px 0px 15px 15px;
  min-width: 900px;
}

.page-content-list-item {
  width: calc(25% - 15px);
  background-color: rgba(28, 164, 243, 0.76);
  border-radius: 5px;
  padding: 10px 15px 5px 15px;
  box-sizing: border-box;
  margin-right: 15px;
}

.page-content-list-item-title{
  font-size: 16px;
  color: #fff;
}

.page-content-list-item-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-content-list-item-number{
  font-weight: 700;
  font-style: normal;
  font-size: 30px;
  color: #fff;
  display: flex;
  justify-content: center;
}

.page-content-list-item-type{
  font-size: 18px;
  text-align: center;
  line-height: 45px;
}

.page-content-list-item-right{
  text-align: right;
  font-size: 0;
}

.page-content-list-item-right img {
  width: 30px;
  object-fit: cover;
  flex-shrink: 0;
}

.text-line-1 {
	display: -webkit-box;
	word-break: break-all;
	/*超出文字用省略号代替*/
	text-overflow: ellipsis;
	/*竖直方向的超出和隐藏*/
	-webkit-box-orient: vertical;
	/*设定行数为2*/
	-webkit-line-clamp: 1;
	/*多出部分隐藏*/
	overflow: hidden;
}








.searchchart_top {
  display: flex;
  justify-content: space-between;
  align-self: center;
  width: 95%;
  min-width: 1400px;
}


.chartmainbarnumber>div {
  width: 100%;
}

.chartheader {
  color: #000;
  font-size: 16px;
  text-align: center;
}

.chartbottom {
  width: 100%;
  padding: 0px 30px;
  box-sizing: border-box;
}

.chartbottom .text {
  color: #000;
  font-size: 13px !important;
  cursor: pointer;
  margin-top: 5px;
}

.chartinum {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chartinum>div {
  text-align: center;
}

.chartinum .num {
  color: #000;
  font-size: 13px !important;
  cursor: pointer;
}

.chartinum text {
  color: #333333;
  font-size: 14px;
}

.searchchart_bottom {
  margin-top: 20px;
}

.searchchart_header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-weight: bold;
}

.searchchart_header>div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.searchchart_header>div+div {
  margin-left: 10px;
}

@media only screen and (max-width: 1600px) and (min-width: 1400px) {
  #chartmainbarCircle {
    width: 230px !important;
    height: 200px !important;
  }

  #chartmainbarCircle>>>div {
    width: 230px !important;
    height: 200px !important;
  }

  #chartmainbarCircle>>>canvas {
    width: 230px !important;
    height: 200px !important;
  }

  #chartmainbar {
    width: 230px !important;
    height: 200px !important;
  }

  #chartmainbar>>>div {
    width: 230px !important;
    height: 200px !important;
  }

  #chartmainbar>>>canvas {
    width: 230px !important;
    height: 200px !important;
  }

  .chartmainbarnumber {
    width: 330px !important;
    margin-top: 25px;
  }

  .chartbottom {
    padding: 0 !important;
  }

  .chartinum {
    margin-top: 10px !important;
  }
}

@media only screen and (min-width: 1250px) and (max-width: 1300px) {
  #chartmainbarCircle {
    width: 190px !important;
    height: 170px !important;
  }

  #chartmainbarCircle>>>div {
    width: 190px !important;
    height: 170px !important;
  }

  #chartmainbarCircle>>>canvas {
    width: 190px !important;
    height: 170px !important;
  }

  #chartmainbar {
    width: 190px !important;
    height: 170px !important;
  }

  #chartmainbar>>>div {
    width: 190px !important;
    height: 170px !important;
  }

  #chartmainbar>>>canvas {
    width: 190px !important;
    height: 170px !important;
  }

  .chartmainbarnumber {
    width: 280px !important;
    margin-top: 25px;
  }

  .chartbottom {
    padding: 0 !important;
  }

  .chartinum {
    margin-top: 10px !important;
  }

  .searchchart_top {
    width: 90%;
  }
}

@media only screen and (min-width: 1320px) and (max-width: 1400px) {
  #chartmainbarCircle {
    width: 210px !important;
    height: 180px !important;
  }

  #chartmainbarCircle>>>div {
    width: 210px !important;
    height: 180px !important;
  }

  #chartmainbarCircle>>>canvas {
    width: 210px !important;
    height: 180px !important;
  }

  #chartmainbar {
    width: 210px !important;
    height: 180px !important;
  }

  #chartmainbar>>>div {
    width: 210px !important;
    height: 180px !important;
  }

  #chartmainbar>>>canvas {
    width: 210px !important;
    height: 180px !important;
  }

  .chartmainbarnumber {
    width: 300px !important;
    margin-top: 25px;
  }

  .chartbottom {
    padding: 0 !important;
  }

  .chartinum {
    margin-top: 10px !important;
  }

  .searchchart_top {
    width: 90%;
  }
}

@media only screen and (max-width: 1250px) {
  #chartmainbarCircle {
    width: 160px !important;
    height: 140px !important;
  }

  #chartmainbarCircle>>>div {
    width: 160px !important;
    height: 140px !important;
  }

  #chartmainbarCircle>>>canvas {
    width: 160px !important;
    height: 140px !important;
  }

  #chartmainbar {
    width: 160px !important;
    height: 140px !important;
  }

  #chartmainbar>>>div {
    width: 160px !important;
    height: 140px !important;
  }

  #chartmainbar>>>canvas {
    width: 160px !important;
    height: 140px !important;
  }

  .chartmainbarnumber {
    width: 280px !important;
    margin-top: 25px;
  }

  .chartbottom {
    padding: 0 !important;
  }

  .chartinum {
    margin-top: 10px !important;
  }

  .searchchart_top {
    width: 90%;
  }
}

.searchchart_echarts {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* min-width: 1400px; */
}

.searchchart_echarts>div {
  width: 49.5%;
}

.echartsleft {
  margin-right: 20px;
}

#oneChart>>>div:first-child {
  width: 100% !important;
}

#oneChart>>>canvas {
  width: 100% !important;
}

#twoChart>>>div:first-child {
  width: 100% !important;
}

#twoChart>>>canvas {
  width: 100% !important;
}

.pamadeng {
  background: white;
  height: 40px;
  /* font-size: 16px; */
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
}

.pamadeng img {
  width: 20px;
  height: 20px;
  margin: 9px 15px;
  position: absolute;
}
</style>